import React from "react";
import "../css/ourservice.css";

/*
  Import images from src/assets so bundlers (CRA/Vite) include them.
  Make sure your files are:
    src/assets/repair1.jpg ... src/assets/repair6.jpg
*/
import repair1 from "../assets/repair1.jpg";
import repair2 from "../assets/repair2.jpg";
import repair3 from "../assets/repair3.jpg";
import repair4 from "../assets/repair4.jpg";
import repair5 from "../assets/repair5.jpg";
import repair6 from "../assets/repair6.jpg";

const services = [
  { id: 1, img: repair1, title: "AC Repair", desc: "Quick and efficient air conditioning repair services." },
  { id: 2, img: repair2, title: "AC Installation", desc: "Professional air conditioning installation services for homes and businesses." },
  { id: 3, img: repair3, title: "AC Cleaning", desc: "Thorough cleaning to maintain peak AC efficiency." },
  { id: 4, img: repair4, title: "AC Uninstallation", desc: "Professional AC uninstallation: safe, efficient, and eco-friendly service." },
  { id: 5, img: repair5, title: "AC Annual Maintenance", desc: "Ensure optimal performance with our annual AC maintenance service." },
  { id: 6, img: repair6, title: "AC Gas Refill Service", desc: "Expert AC gas refill service for optimal cooling performance." },
];

export default function OurService() {
  const phone = "72378 98275";
  return (
    <section className="our-service-section" aria-labelledby="our-services-heading">
      <div className="container">
        <div className="section-header">
          <p className="eyebrow">OUR SERVICES</p> <br />
          <h2 id="our-services-heading">Comprehensive AC Solutions for Every Need</h2>
        </div>

        <div className="cards-wrap" role="list">
          {services.map((s) => (
            <article className="service-card" key={s.id} role="listitem" tabIndex="0">
              <div className="service-image" aria-hidden="false">
                <img src={s.img} alt={s.title} loading="lazy" />
              </div>

              <div className="service-body">
                <h3 className="service-title">{s.title}</h3>
                <p className="service-desc">{s.desc}</p>
                <a className="service-phone" href={`tel:${phone}`} aria-label={`Call us at ${phone}`}>
                  CALL US {phone}
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
